import { reportApi } from '../../api';
import { ReportRequest } from '../../types/report/ReportTypes';

/**
 * Servicio para exportación de reportes.
 * La lógica de descarga (blob, filename, errores)
 * vive en apiHandler.downloadFileFromBlob
 */
const ReportExportService = {
  /**
   * Exporta un reporte dinámico en Excel.
   *
   * Endpoint:
   * POST /api/reports/export
   */
  exportReport: async (request: ReportRequest): Promise<string> => {
    // 🔥 Delegamos TODO al apiHandler
    return await reportApi.downloadFileFromBlob('/export', request);
  },
};

export default ReportExportService;
